import React from 'react';
import { bagSvg, cartFullSvg } from './svg';
import { useDispatch } from 'react-redux';
import { dealAction } from '../../../../store/deal-slice';

function BasketFull({ checkKYCStatus, isCheckout, placeOrder }) {
    const dispatch = useDispatch();
    return (
        <div id="NoRewards">
            <div class="flex flex-col items-center justify-center py-8  bg-white border border-gray-300 rounded-lg shadow-sm  w-[95%] md:w-[70%] lg:w-[50%] mx-auto mt-14">
                <div class=" flex flex-col lg:flex-row items-center gap-2">
                    <div class="">{cartFullSvg}</div>
                    <hr className=" hidden lg:block h-24 w-[2px] bg-gray-100 mx-3"></hr>
                    <hr className=" block lg:hidden w-32 h-[2px] bg-gray-100 mt-2"></hr>
                    <div className="flex flex-col items-center lg:items-start">
                        <div className="flex flex-col items-center justify-center lg:items-start text-center">
                            <h3 class="text-lg md:text-xl font-bold mt-2 lg:mt-0 ">
                                Your Gift Basket is Full
                            </h3>
                            {isCheckout && (
                                <p className=" text-sm ">
                                    Proceed to{' '}
                                    <a
                                        onClick={placeOrder}
                                        className="text-blue-800 text-sm  cursor-pointer"
                                    >
                                        Place Order
                                    </a>{' '}
                                    or Remove some Items to see other rewards.
                                </p>
                            )}
                            {!isCheckout && (
                                <p className=" text-sm mt-2">
                                    Continue to{' '}
                                    <a
                                        onClick={() => checkKYCStatus()}
                                        className="text-blue-800 text-sm  cursor-pointer"
                                    >
                                        Checkout
                                    </a>{' '}
                                    or{' '}
                                    <a
                                        // onClick={(event) => {
                                        //     event.stopPropagation();
                                        //     window.dispatchEvent(
                                        //         new Event('cartUpdated')
                                        //     );
                                        //     dispatch(
                                        //         dealAction.setCartModalVisible(
                                        //             true
                                        //         )
                                        //     );
                                        // }}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            window.dispatchEvent(
                                                new CustomEvent('cartUpdated', {
                                                    detail: { showModal: true }
                                                })
                                            );
                                            dispatch(
                                                dealAction.setCartModalVisible(
                                                    true
                                                )
                                            );
                                        }}
                                        className="text-blue-800 text-sm cursor-pointer"
                                    >
                                        Remove Some Items
                                    </a>{' '}
                                    to see other rewards.
                                </p>
                            )}
                        </div>
                        <button
                            class="px-4 py-2  text-sm  text-white bg-primary  rounded-md  mt-3 flex items-center gap-2"
                            onClick={(event) => {
                                event.stopPropagation();
                                if (isCheckout) {
                                    placeOrder();
                                    return;
                                }
                                window.dispatchEvent(
                                    new CustomEvent('cartUpdated', {
                                        detail: { showModal: true }
                                    })
                                );
                                // window.dispatchEvent(new Event('cartUpdated'));
                                dispatch(dealAction.setCartModalVisible(true));
                            }}
                        >
                            {bagSvg}{' '}
                            <span>
                                {isCheckout
                                    ? 'Place Order'
                                    : 'Go To Gift Basket'}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BasketFull;
